import React, { useId } from 'react';

export default function CaptureFlowSelect({ value = 'captureOnly', onChange }) {
  const legacy = value === 'captureAndSubmit';
  const id = useId();
  return (
    <div className="input-pair capture-flow-field">
      <label htmlFor={id}>Capture Flow</label>
      <select id={id} aria-describedby={`${id}-help`} value={value} onChange={e => onChange(e.target.value)}>
        <option value="captureOnly">Capture Only</option>
        {legacy && (
          <option value="captureAndSubmit">Legacy – Capture + Submit (keeps current record)</option>
        )}
        <option value="captureSubmitAndReset">Capture + Submit + New Record</option>
      </select>
      <small id={`${id}-help`}>
        {legacy
          ? 'Deprecated: submits and keeps the current record. Choose New Record for repeated captures.'
          : value === 'captureSubmitAndReset'
            ? 'Capture/save, submit the record, and start a new record for the next capture.'
            : 'Capture/save media on the current record without submitting it.'}
      </small>
    </div>
  );
}
